/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown>, movement: NonNullable<unknown> }} Prescription_Notice_Slot_UnfilledInputs */

const en_us2_prescription_notice_slot_unfilled = /** @type {(inputs: Prescription_Notice_Slot_UnfilledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: nothing for ${i?.movement} fits your equipment and restrictions.`)
};

const pt_br2_prescription_notice_slot_unfilled = /** @type {(inputs: Prescription_Notice_Slot_UnfilledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: nada para ${i?.movement} cabe no seu equipamento e restrições.`)
};

const es_419_prescription_notice_slot_unfilled = /** @type {(inputs: Prescription_Notice_Slot_UnfilledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: nada de ${i?.movement} se ajusta a tu equipo y tus restricciones.`)
};

const pt_pt2_prescription_notice_slot_unfilled = /** @type {(inputs: Prescription_Notice_Slot_UnfilledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: nada para ${i?.movement} se adequa ao teu equipamento e restrições.`)
};

const fr_fr2_prescription_notice_slot_unfilled = /** @type {(inputs: Prescription_Notice_Slot_UnfilledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} : rien pour « ${i?.movement} » ne convient à ton équipement et à tes restrictions.`)
};

const de_de2_prescription_notice_slot_unfilled = /** @type {(inputs: Prescription_Notice_Slot_UnfilledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: Für ${i?.movement} passt nichts zu deiner Ausstattung und deinen Einschränkungen.`)
};

const it_it2_prescription_notice_slot_unfilled = /** @type {(inputs: Prescription_Notice_Slot_UnfilledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: niente per ${i?.movement} è compatibile con la tua attrezzatura e le tue restrizioni.`)
};

/**
* | output |
* | --- |
* | "{day}: nothing for {movement} fits your equipment and restrictions." |
*
* @param {Prescription_Notice_Slot_UnfilledInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_notice_slot_unfilled = /** @type {((inputs: Prescription_Notice_Slot_UnfilledInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Notice_Slot_UnfilledInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_notice_slot_unfilled(inputs)
	if (locale === "es-419") return es_419_prescription_notice_slot_unfilled(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_notice_slot_unfilled(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_notice_slot_unfilled(inputs)
	if (locale === "de-DE") return de_de2_prescription_notice_slot_unfilled(inputs)
	if (locale === "it-IT") return it_it2_prescription_notice_slot_unfilled(inputs)
	return en_us2_prescription_notice_slot_unfilled(inputs)
});
export { prescription_notice_slot_unfilled as "prescription.notice.slot_unfilled" }